module.exports = __webpack_public_path__ + "img/bilal.ff6f0ec2.jpeg";